module.exports = __webpack_public_path__ + "static/group-bg-1-f0174fb2ffbb031dea7e1ab834152c32.jpg";